import React from "react"
import { IconMoon, IconSun } from "@tabler/icons-react"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { useTheme } from "@/components/theme-provider"
import { NotificationsBell } from "@/components/notifications-bell"

export function SiteHeader({ title = "Documents", status }: { title?: string; status?: React.ReactNode }) {
  const { theme, toggleTheme } = useTheme()

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full min-w-0 items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1 shrink-0" />
        <Separator
          orientation="vertical"
          className="mx-2 hidden shrink-0 data-[orientation=vertical]:h-4 sm:block"
        />
        <h1 className="truncate text-base font-medium">{title}</h1>
        {status}
        <div className="ml-auto flex shrink-0 items-center gap-2">
          <NotificationsBell />
          <Button variant="ghost" size="icon" onClick={toggleTheme} className="size-8">
            {theme === "dark" ? <IconSun className="size-4" /> : <IconMoon className="size-4" />}
          </Button>
        </div>
      </div>
    </header>
  )
}
